import React from 'react'
import './status.css'

export const Status = (props) =>{
    return(
        <div className={`status ` + props.status}>

        </div>
    )
}